export default {
    add_patient: "Добавить пациента",
    add_task: "Добавить задачу",
    calls: "Звонки",
    chat_panel: "Панель чатов",
    clinic_id: "Id клиники",
    confirm: "Подтвердить",
    expenses: "Расходы",
    high: "Высокая",
    low: "Низкая",
    medium: "Средняя",
    no_notifications: "Уведомлений нет",
    read_all: "Прочитано все",
    remove_confirmation: "Отменить подтверждение",
    tasks: "Задачи"
}
